import { render, staticRenderFns } from "./AlertSetting.vue?vue&type=template&id=16631e9e&scoped=true&"
import script from "./AlertSetting.vue?vue&type=script&lang=js&"
export * from "./AlertSetting.vue?vue&type=script&lang=js&"
import style0 from "./AlertSetting.vue?vue&type=style&index=0&id=16631e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16631e9e",
  null
  
)

export default component.exports